export const GENDER_OPTIONS = [
  { key: "male", label: "Male" },
  { key: "female", label: "Female" },
  { key: "other", label: "Other" },
  { key: "prefer_not_to_say", label: "Prefer not to say" },
];

export const CUSTOMER_TYPE_OPTIONS = [
  { key: "nigerian_freelancers", label: "Nigerian Freelancers" },
  { key: "developers_tech_builders", label: "Developers & Tech Builders" },
  { key: "creative_agencies_studios", label: "Creative Agencies & Studios" },
  { key: "lawyers_consultants", label: "Lawyers & Consultants" },
  { key: "brands_businesses", label: "Brands & Businesses" },
  { key: "creators_selling_services", label: "Creators Selling Services" },
];

export function formatAddressLines(address) {
  if (!address) return "Not set";
  if (address.formattedAddress) return address.formattedAddress;
  const parts = [
    address.line1,
    [address.city, address.state].filter(Boolean).join(", "),
    address.postalCode,
    address.country,
  ].filter((p) => p && String(p).trim());
  return parts.length ? parts.join(" · ") : "Not set";
}

export function formatDobLabel(iso) {
  if (!iso) return "Not set";
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-NG", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
